import Crud from '../views/Empresa/Crud'
import Entity from '../views/Empresa/Add'

let routes = {
    path: '/empresas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/empresas/add',
            name: 'NewEmpresa',
            component: Entity
        },
        {
            path: '/empresas/edit/:id?',
            name: 'EditEmpresa',
            component: Entity
        },
        {
            path: '/empresas',
            name: 'list-empresas',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Empresas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
